import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import Api from "@services/Api";
import { toastError } from "@utils/functions";
import { Category, Product } from "@utils/types";
import store from "./index";

const products = createSlice({
  name: "products",
  initialState: {
    count: 0,
    products: [] as Product[],
    loading: true,
    filters: {
      searchText: "",
      category: null as Category | null,
      orderBy: "",
      currentPage: 1,
    },
  },
  reducers: {
    setProducts(state, action: PayloadAction<Product[]>) {
      state.products = action.payload;
    },
    setLoadingProducts(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setProductsFilterCurrentPage(state, action: PayloadAction<number>) {
      state.filters.currentPage = action.payload;
    },
    setProductFilterText(state, action: PayloadAction<string>) {
      state.filters.searchText = action.payload;
    },
    setProductFilterCategory(state, action: PayloadAction<Category | null>) {
      state.filters.category = action.payload;
    },
    setProductFilterOrderBy(state, action: PayloadAction<string>) {
      state.filters.orderBy = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProducts.fulfilled, (state, action) => {
      state.products = state.filters.currentPage > 1 ? [...state.products, ...action.payload.products] : action.payload.products;
      state.count = action.payload.count;
      state.loading = false;
    });
    builder.addCase(fetchProducts.pending, (state) => {
      state.loading = true;
    });
  },
});

export default products.reducer;

export const { setProductFilterText, setProductFilterCategory, setProductFilterOrderBy, setProductsFilterCurrentPage, setProducts, setLoadingProducts } =
  products.actions;

export const fetchProducts = createAsyncThunk("products/fetchProducts", async () => {
  const state = store.getState();
  try {
    let url = `/product?company_code=${state.company.data.code}&page=${state.products.filters.currentPage}`;
    if (state.products.filters.searchText) url += `&search=${state.products.filters.searchText}`;
    if (state.products.filters.orderBy) url += `&orderBy=${state.products.filters.orderBy}`;
    if (state.products.filters.category) url += `&categories=[${state.products.filters.category.id}]`;
    const { data } = await Api.get(url);
    return data;
  } catch (error) {
    console.log(error, "error on fetchProducts()");
    toastError(error);
  }
});
